import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommitteeRoutingModule } from './committee-routing.module';
import { CommitteeMembersComponent } from './committee-members/committee-members.component';
import { SharedModule } from '../shared/shared.module';
import { MainMemberListComponent } from './main-member-list/main-member-list.component';
import { MemberDetailsComponent } from './member-details/member-details.component';
import { MemberDeleteComponent } from './member-delete/member-delete.component';
import { ActivememberComponent } from './activemember/activemember.component';
import { CheckActiveDialogComponent } from './check-active-dialog/check-active-dialog.component';
import { VillageListComponent } from './village-list/village-list.component';
import { VillageMemberListComponent } from './village-member-list/village-member-list.component';
import { ActivistComponent } from './activist/activist.component';
import { ActivistMemberListComponent } from './activist-member-list/activist-member-list.component';
import { MatTabsModule } from '@angular/material/tabs';
import { AllmemberlistComponent } from './allmemberlist/allmemberlist.component';



@NgModule({
  declarations: [
    CommitteeMembersComponent,
    MainMemberListComponent,
    MemberDetailsComponent,
    MemberDeleteComponent,
    ActivememberComponent,
    CheckActiveDialogComponent,
    VillageListComponent,
    VillageMemberListComponent,
    ActivistComponent,
    ActivistMemberListComponent,
    AllmemberlistComponent,    
  ],
  imports: [
    CommonModule,
    MatTabsModule,
    CommitteeRoutingModule,
    SharedModule,
  ]
})
export class CommitteeModule { }
